import {getTestProps} from '@benchling/js-test-utils';
import {Alert} from '@mantine/core';
import React from 'react';

import type {MissingRequiredField} from 'constants/SampleConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {formatMissingRequiredFieldNames} from './missingRequiredFieldsUtil';
import useShowMissingRequiredFieldWarnings from './useShowMissingRequiredFieldWarnings';

interface Props {
  missingRequiredFields: ReadonlyArray<MissingRequiredField> | null | undefined;
}

/** Page-level warning for a container missing values for required fields. */
export default function MissingRequiredFieldsBanner({missingRequiredFields}: Props): JSX.Element | null {
  const showWarnings = useShowMissingRequiredFieldWarnings();
  if (!showWarnings || missingRequiredFields == null || missingRequiredFields.length === 0) {
    return null;
  }
  const isSingle = missingRequiredFields.length === 1;
  const noun = isSingle ? 'field' : 'fields';
  return (
    <Alert
      icon={<BenchlingIcon icon="exclamation-circle" />}
      title={`Missing required ${noun}`}
      variant="error"
      {...getTestProps({component: 'MissingRequiredFieldsBanner'})}
    >
      This container is missing values for required {noun}:{' '}
      {formatMissingRequiredFieldNames(missingRequiredFields)}.
    </Alert>
  );
}
